module.exports = __webpack_public_path__ + "static/media/green-logo.72067b7a.svg";